import { fetchAuthSession } from "aws-amplify/auth";
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";
import executeApi from './executeApi';
import { CreatePDFApiRequest } from "../model/apiRequestModel";
import { CreatePDFApiResponse } from "../model/apiResponseModel";

/** 帳票出力API */
const createPdf = async (requestObj: CreatePDFApiRequest): Promise<CreatePDFApiResponse> => {
    // 認証
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString();
    // EyesFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    // 帳票出力API PATH
    const path = "/pdf/kigyo/execution";
    const request = JSON.stringify(requestObj)

    try {
        const response = await executeApi(baseURL, path, jwtToken, 0, request);
        // レスポンスコード返却
        if (!response || response.data.resCd == "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg
            }
        } else {
            // ダウンロード実行
            const url = response.data.data.url;
            if (url !== "") {
                let link = document.createElement('a');
                link.download = url;
                link.href = url;
                link.click();
            }
            // レスポンスコード返却
            return response.data.resCd

        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg
        };
    }
};

export default createPdf;
